import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "24",
  viewBox: "0 0 21 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.7222 5.73906V4.89906C14.7222 3.72295 14.7222 3.1349 14.4921 2.68568C14.2897 2.29054 13.9668 1.96928 13.5695 1.76795C13.1179 1.53906 12.5268 1.53906 11.3444 1.53906H9.65556C8.47322 1.53906 7.88206 1.53906 7.43046 1.76795C7.03323 1.96928 6.71027 2.29054 6.50788 2.68568C6.27778 3.1349 6.27778 3.72295 6.27778 4.89906V5.73906M8.38889 11.5141V16.7641M12.6111 11.5141V16.7641M1 5.73906H20M17.8889 5.73906V17.4991C17.8889 19.2632 17.8889 20.1453 17.5437 20.8191C17.2401 21.4118 16.7557 21.8937 16.1599 22.1957C15.4825 22.5391 14.5957 22.5391 12.8222 22.5391H8.17778C6.40428 22.5391 5.51753 22.5391 4.84014 22.1957C4.24429 21.8937 3.75986 21.4118 3.45626 20.8191C3.11111 20.1453 3.11111 19.2632 3.11111 17.4991V5.73906",
      stroke: "#AA1E2D",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }